module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ReserveButton/images/gold-normal-50.04b10b98.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveButton/images/gold-normal-50.png
// module id = 3447
// module chunks = 11